<section class="full-height">
  <vdw-tabs-menu-card
    [icon]="isEditingWeaveProduct() ? 'details-blue' : 'add-blue'"
    [action]="action | bmsTranslate: {object: translationKeyForWeaveProducts | bmsTranslate: {count: 1} | lowercase}"
    [title]="addWeaveProductForm.controls.name.value"
    [isInUse]="isWeaveProductBeingUsed() && weaveProductIsLocked"
    [invalidFormMessageError]="canShowInvalidFormMessageError()"
    [isLoading]="isLoadingWeaveProduct"
    [hasPermissionToEdit]="hasEditPermission()"
    [isCreateNewPage]="!isEditingWeaveProduct()"
    [saving]="saving"
    [identifier]="HEADER_IDENTIFIER"
    (backEvent)="navigateBack()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="saveWeaveProduct(SAVE_TYPE.SAVE)"
    (saveAndCloseEvent)="saveWeaveProduct(SAVE_TYPE.SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="saveWeaveProduct(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (deleteEvent)="deleteWeaveProduct()"
    (duplicateEvent)="duplicateWeaveProduct()"
    (inUseEvent)="openConflictsDialog()"
  ></vdw-tabs-menu-card>

  <ng-container *appHasPermission="texstyleEditPermission">
    <div *ngIf="isWeaveProductBeingUsed()" class="unlock-in-use-wrapper">
      <app-unlock-in-use
        [entityKey]="translationKeyForWeaveProducts"
        [conflictsRepository]="weaveProducts"
        [locked]="weaveProductIsLocked"
        [id]="weaveProductToSave.id"
        [name]="weaveProductToSave.name"
        (lockedChange)="unlockWeaveProduct()"
      ></app-unlock-in-use>
    </div>
  </ng-container>

  <div class="tab-height card-wrapper">
    <mat-card *ngIf="canShowAddWeaveProductForm()" class="skeleton-wrapper" [class.skeleton]="isLoadingWeaveProduct" [@fadeIn]="isLoadingWeaveProduct">
      <mat-card-content class="form-scrollable-content">
        <article>
          <form class="flex-column" [formGroup]="addWeaveProductForm" appBreadcrumbFormLinker>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="24px">
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'GENERAL.NAME' | bmsTranslate }}</mat-label>
                  <input matInput type="text" formControlName="name" />
                  <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'">
                    {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
                    <a class="url" [routerLink]="getLoadLink()">{{ 'GENERAL.ACTIONS.LOAD' | bmsTranslate }}</a>
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'required'">
                    {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'GENERAL.VERSION' | bmsTranslate }}</mat-label>
                  <input disabled matInput [value]="getVersionValue()" />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="24px">
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}</mat-label>
                  <input matInput type="number" vdwL10nDecimal [decimals]="true" [maximumFractionDigits]="2" min="1" formControlName="widthInCm" />
                  <span matSuffix>
                    {{ 'GENERAL.UNIT.CENTIMETER' | bmsTranslate }}
                  </span>
                  <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'badInput'">
                    {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'required'">
                    {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'min'">
                    {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'widthInCm'; error: 'max'">
                    {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: maxWidthInCm} }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.PICK_DENSITY' | bmsTranslate }}</mat-label>
                  <input matInput type="number" vdwL10nDecimal [decimals]="true" [maximumFractionDigits]="2" min="1" formControlName="pickDensityInPicksPerCm" />
                  <span matSuffix>
                    {{ 'GENERAL.UNIT.PICKS_PER_CENTIMETER' | bmsTranslate }}
                  </span>
                  <mat-error *vdwCanShowErrorForFormControl="'pickDensityInPicksPerCm'; error: 'badInput'">
                    {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'pickDensityInPicksPerCm'; error: 'required'">
                    {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'pickDensityInPicksPerCm'; error: 'min'">
                    {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="24px">
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>
                    <span>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.STANDARD_SPEED' | bmsTranslate }}</span>
                    <span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    vdwL10nDecimal
                    [decimals]="true"
                    [maximumFractionDigits]="2"
                    min="1"
                    formControlName="standardSpeedInRotationsPerMinute"
                    id="standardSpeedInRotationsPerMinute"
                  />
                  <span matSuffix>
                    {{ 'GENERAL.UNIT.ROTATIONS_PER_MINUTE' | bmsTranslate }}
                  </span>
                  <mat-error *vdwCanShowErrorForFormControl="'standardSpeedInRotationsPerMinute'; error: 'min'">
                    {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'standardSpeedInRotationsPerMinute'; error: 'badInput'">
                    {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>
                    <span>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.STANDARD_EFFICIENCY' | bmsTranslate }}</span>
                    <span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    vdwL10nDecimal
                    [decimals]="true"
                    [maximumFractionDigits]="2"
                    min="0"
                    formControlName="standardEfficiencyInPercentage"
                    id="standardEfficiencyInPercentage"
                  />
                  <span matSuffix>
                    {{ 'GENERAL.UNIT.PERCENTAGE' | bmsTranslate }}
                  </span>
                  <mat-error *vdwCanShowErrorForFormControl="'standardEfficiencyInPercentage'; error: 'min'">
                    {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0} }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'standardEfficiencyInPercentage'; error: 'max'">
                    {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: 100} }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'standardEfficiencyInPercentage'; error: 'badInput'">
                    {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="24px">
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.NUMBER_OF_FEEDERS' | bmsTranslate }}</mat-label>
                  <input matInput type="number" vdwL10nDecimal [decimals]="false" [maximumFractionDigits]="0" min="0" formControlName="numberOfFeeders" id="numberOfFeeders" />
                  <mat-error *vdwCanShowErrorForFormControl="'numberOfFeeders'; error: 'required'">
                    {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'numberOfFeeders'; error: 'min'">
                    {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0} }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'numberOfFeeders'; error: 'max'">
                    {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: maxNumberOfFeeders ?? 32} }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.NUMBER_OF_SHAFTS' | bmsTranslate }}</mat-label>
                  <input matInput type="number" vdwL10nDecimal [decimals]="false" [maximumFractionDigits]="0" min="0" formControlName="numberOfShafts" id="numberOfShafts" />
                  <mat-error *vdwCanShowErrorForFormControl="'numberOfShafts'; error: 'required'">
                    {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'numberOfShafts'; error: 'min'">
                    {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0} }}
                  </mat-error>
                  <mat-error *vdwCanShowErrorForFormControl="'numberOfShafts'; error: 'max'">
                    {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: maxNumberOfShafts ?? 32} }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="24px">
              <div fxFlex class="form-field-skeleton-wrapper">
                <mat-form-field fxFlex>
                  <mat-label>
                    <span>{{ 'GENERAL.DESCRIPTION' | bmsTranslate }}</span>
                    <span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
                  </mat-label>
                  <input matInput formControlName="description" id="description" />
                </mat-form-field>
              </div>
            </div>
          </form>
        </article>
      </mat-card-content>
    </mat-card>
  </div>
</section>
